// One look for every DataGrid in the CRM: white card, soft header, no
// navy banding. Spread onto the grid's `sx`.
const dataGridSx = {
  border: '1px solid #E2E8F0',
  borderRadius: 3,
  backgroundColor: '#FFFFFF',
  overflow: 'hidden',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#F8FAFC',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: '#F8FAFC',
    color: '#64748B',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  '& .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    borderColor: '#EEF2F7',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#F8FAFC',
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus-within':
    {
      outline: 'none',
    },
  '& .MuiDataGrid-footerContainer': {
    borderColor: '#EEF2F7',
  },
  '& .MuiDataGrid-columnSeparator': {
    opacity: 0,
  },
}

export default dataGridSx
